import { RefObject, useEffect, useState } from 'react';

const RESIZE_RECHECK_DEBOUNCE_MS = 150;

const useResizeSignal = (targetRef?: RefObject<HTMLElement | null>): number => {
  const [signal, setSignal] = useState(0);

  useEffect(() => {
    const target = targetRef?.current;

    if (!target || typeof ResizeObserver === 'undefined') {
      return undefined;
    }

    let timeoutId: ReturnType<typeof setTimeout> | undefined;
    const observer = new ResizeObserver(() => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setSignal(value => value + 1), RESIZE_RECHECK_DEBOUNCE_MS);
    });

    observer.observe(target);

    return () => {
      clearTimeout(timeoutId);
      observer.disconnect();
    };
  }, [targetRef]);

  return signal;
};

export default useResizeSignal;
